import type { DevToolsPanelHeaderProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsPanel/DevToolsPanelHeader/index.types';
import { DevToolsRegistrationPill } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsPanel/DevToolsRegistrationPill';
import React from 'react';

/**
 * DevToolsPanelHeader - What this panel is, and whether the phone is usable
 */
export const DevToolsPanelHeader: React.FC<DevToolsPanelHeaderProps> = ({
  sipStatus,
  onClose,
}) => (
  <div className="flex h-11 flex-shrink-0 items-center gap-2.5 border-b border-zinc-800 bg-zinc-900 pl-3.5 pr-2.5">
    <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-md border border-emerald-800 bg-emerald-950">
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        className="text-emerald-400"
        aria-hidden="true"
      >
        <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1.1 1A16 16 0 0 1 4 5.1 1 1 0 0 1 5 4z" />
      </svg>
    </span>

    <h2 className="text-[13px] font-semibold tracking-[-0.01em] text-zinc-200">
      Softphone DevTools
    </h2>

    <div className="flex-1" />

    <DevToolsRegistrationPill status={sipStatus} />

    <button
      type="button"
      onClick={onClose}
      className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg text-[15px] leading-none text-zinc-400 transition-colors hover:bg-red-950 hover:text-red-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/40"
      aria-label="Close"
    >
      ×
    </button>
  </div>
);
